import React from 'react';
import {
    ShoppingBag,
    CheckCircle2,
    ChefHat,
    Package,
    Truck,
    MapPin,
    Bike,
} from 'lucide-react';

// ── Order Progress Flow ──────────────────────────────────────────
export const getOrderFlow = (driverId?: string | null, deliveryType?: string): Array<{ status: string; label: string; icon: React.ReactNode }> => {
    const flow = [
        { status: 'pending', label: 'Placed', icon: <ShoppingBag className="w-4 h-4" /> },
        {
            status: 'accepted',
            label: driverId ? 'Accepted by Driver' : 'Accepted by Store',
            icon: <CheckCircle2 className="w-4 h-4" />
        },
        { status: 'in_progress', label: 'Preparing', icon: <ChefHat className="w-4 h-4" /> },
        { status: 'ready_for_pickup', label: 'Ready', icon: <Package className="w-4 h-4" /> },
    ];

    if (deliveryType === 'takeaway') {
        flow.push({ status: 'delivered', label: 'Completed', icon: <CheckCircle2 className="w-4 h-4" /> });
    } else {
        flow.push(
            // { status: 'arrived', label: 'Driver Arrived', icon: <MapPin className="w-4 h-4" /> },
            { status: 'picked_up', label: 'Picked Up', icon: <CheckCircle2 className="w-4 h-4" /> },
            { status: 'out_for_delivery', label: 'Out for Delivery', icon: <Truck className="w-4 h-4" /> },
            { status: 'destination_arrived', label: 'Destination Arrived', icon: <MapPin className="w-4 h-4" /> },
            { status: 'delivered', label: 'Delivered', icon: <CheckCircle2 className="w-4 h-4" /> }
        );
    }
    return flow;
};

// ── Normalize status based on driver assignment ──────────────────
export const getNormalizedStatus = (status: string, driverId?: string | null): string => {
    const rawStatus = status.toLowerCase();

    let normalizedStatus = rawStatus;
    // Handle aliases so progress bar doesn't break
    if (rawStatus === 'created') normalizedStatus = 'pending';

    // If driver is already assigned but status hasn't moved past accepted, 
    // show "Preparing" (in_progress) in the order flow.
    if (driverId && ['created', 'pending', 'accepted'].includes(rawStatus)) {
        normalizedStatus = 'in_progress';
    }

    if (rawStatus === "refunded") {
        normalizedStatus = "delivered"
    }

    return normalizedStatus;
};

// ── Get index of current status in ORDER_FLOW ────────────────────
export const getStatusIndex = (status: string, driverId?: string | null, deliveryType?: string): number => {
    const normalizedStatus = getNormalizedStatus(status, driverId);
    const flow = getOrderFlow(driverId, deliveryType);
    return flow.findIndex((s) => s.status === normalizedStatus);
};
